import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from '../../shared/shared.service';
import { GlobalVariable } from '../../shared/global';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { MatDialog } from '@angular/material';
import { LoggerService } from 'app/logger/logger.service';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	// public variable define
	percent: number;
	remaining_days: number;
	month_total_days: number;
	circle_class: string;
	service_balance: any;
	is_loader: boolean;
	is_service_not_start: boolean;
	negative_balance: string;
	is_not_enroll_sg: boolean;
	is_day_greater: boolean;
	private person_details: any;
	public autopay_amount: number;
	public minimum_balance: number;
	public auto_pay: any;
	public card_ending_digit: any;
	public card_name: any;
	public is_payment_make: boolean;
	public isCashOnly: boolean;
	public rewardDetails: any;
	public reward_token: string;
	public reward_url: string;
	public skip_otp: boolean = false;
	balanceTooltip: string;
	dppBalance: number = 0;
	dabBalance: number = 0;

	constructor(private meta: Meta, private title: Title,
		private activatedRoute: ActivatedRoute,
		private sharedService: SharedService,
		private localStorageService: LocalStorageService,
		private router: Router,
		private dashboardService: DashboardService,
		private dialog: MatDialog,
		private logger: LoggerService
	) {
		this.addUpdateMetaTags();
		this.reward_url = GlobalVariable.rewardsUrl + 'login/login_by_stream/'

		// this.sharedService.setHeaderTitleDynamicVal('dashboard', '', 'Account Number ');
		this.sharedService.setHeaderTitle('default_page');
		if (this.localStorageService.get('token') != null) {
			const that = this.sharedService;
			setTimeout(function () {
				that.setHeaderErrorMessage('dashboard', false, 'notification error', '');
				that.setHeaderTitle('dashboard');
			}, 10);
			this.is_loader = true;
			this.minimum_balance = 0;
			this.autopay_amount = 0;
			this.auto_pay = false;
			this.is_payment_make = true;
			this.isCashOnly = false;
			this.balanceTooltip = "";

			this.sharedService.setLoader('dashboard', true);
			this.skip_otp = this.localStorageService.get('skip_otp');
			let methodName = this.constructor.name + '.verifyToken';
			this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
				.then(res => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						response: res
					};
					this.logger.logInfo(JSON.stringify(logObj));
					if (res.status === 'success' && res.isTerminated === false && res.results != null) {
						const person = res.results[0]['personal'];
						const service = res.results[0]['service'];
						this.person_details = person[0];
						this.minimum_balance = this.person_details['balThreshold'];
						this.autopay_amount = this.person_details['autoPayAmount'];
						this.isCashOnly = res.cashOnly;
						this.sharedService.setCashOnlyUser(this.isCashOnly);
						let otp_verified = false;
						if (this.person_details['mobilePhoneNumber'] != undefined
							&& this.person_details['mobilePhoneNumber'].trim() != "") {
							otp_verified = this.person_details['isOtpVerify'] === 1;
						}

						if (this.person_details['email'] != undefined
							&& this.person_details['email'].trim() != "") {
							otp_verified = otp_verified || this.person_details['isEmailVerify'] === 1;
						}

						if (otp_verified || this.skip_otp || this.auto_pay) {
							this.getRewardDetail(this.person_details['accountNumber']);

							var dataLayerEvent = 'my account - dashboard';
							(window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': this.person_details.id.toString(), 'accountNumber': this.person_details.accountNumber.toString() });
							this.sharedService.setHeaderUserLoggedIn('dashboard', true, this.person_details);
							this.sharedService.setHeaderTitleDynamicVal('dashboard', '', 'Account Number ' + this.person_details['accountNumber']);
							// account detail
							if (!res.isEnrolled) {
								this.remaining_days = 0;
								this.service_balance = 0.0;
								this.dialog.open(DashboardInfo);
								if (this.is_loader) {
									this.is_loader = false;
								}
								this.sharedService.setLoader('dashboard', false);
								this.circle_class = '';
								this.is_not_enroll_sg = true;
							} else {
								let methodName1 = this.constructor.name + '.getAutoPay';
								this.dashboardService.getAutoPay(this.localStorageService.get('token')).then(res1 => {
									let logObj = {
										method: methodName1,
										request: 'token : [masked]',
										response: res1
									};
									this.logger.logInfo(JSON.stringify(logObj));
									if (res1.status === 'success') {
										this.auto_pay = res1.autopayActive;
										if (this.auto_pay) {
											this.card_ending_digit = res1.accountNumber;
											this.card_ending_digit = this.card_ending_digit.substring(this.card_ending_digit.length - 4);
											this.card_name = res1.type;
										}
									}
								}, (error) => {
									let logObj = {
										method: methodName1,
										request: "token : [masked]",
										exception: error
									};
									this.logger.logError(JSON.stringify(logObj));
								}).catch((ex) => {
									let logObj = {
										method: methodName1,
										request: "token : [masked]",
										exception: ex
									};
									this.logger.logError(JSON.stringify(logObj));
								});

								let methodName2 = this.constructor.name + '.getAccountDetail';
								this.dashboardService.getAccountDetail({ 'token': this.localStorageService.get('token') })
									.then(response => {
										let logObj = {
											method: methodName2,
											request: "token : [masked]",
											response: response
										};
										this.logger.logInfo(JSON.stringify(logObj));
										if (response.result.status === 'success') {
											this.percent = 100;
											this.remaining_days = response.result.daysRemaining;
											if (this.remaining_days > 30) {
												this.remaining_days = 30;
												this.is_day_greater = true;
											}
											this.month_total_days = 30;
											this.circle_class = '';
											this.service_balance = response.result.accountBalance;
											this.dppBalance = response.result.dppBalance;
											this.dabBalance = response.result.dabBalance;

											this.is_service_not_start = true;
											if (this.service_balance < 0) {
												this.negative_balance = 'negative-balance';
												this.balanceTooltip = "The $ required and estimated days remaining is based on account balance divided by average daily charges"
											}
											this.percent = Math.floor((this.remaining_days * 100) / this.month_total_days);

											if (response.result.accStatusMap !== null) {
												if (response.result.accStatusMap['satusbarcolor'] === 'Red') {
													that.setHeaderErrorMessage('dashboard', true, 'notification error',
														' ' + response.result.accStatusMap['display']);
												} else if (response.result.accStatusMap['satusbarcolor'] === 'Green') {
													that.setHeaderErrorMessage('dashboard', true, 'notification success',
														' ' + response.result.accStatusMap['display']);
												} else if (response.result.accStatusMap['satusbarcolor'] === 'Yellow') {
													that.setHeaderErrorMessage('dashboard', true, 'notification warning',
														' ' + response.result.accStatusMap['display']);
												}
												if (!response.result.accStatusMap['canmakepayment']) {
													this.is_payment_make = false;
													this.is_service_not_start = false;
												}
											}
										} else {
											this.remaining_days = 0;
											this.service_balance = 0.0;
										}
										if (this.is_loader) {
											this.is_loader = false;
										}
										this.sharedService.setLoader('dashboard', false);
										if (this.remaining_days <= 7) {
											this.circle_class = 'yellow';
										}
										if (this.remaining_days <= 2) {
											this.circle_class = 'red';
										}
										if (this.remaining_days === 0) {
											this.circle_class = '';
										}
									}, (error) => {
										let logObj = {
											method: methodName2,
											request: "token : [masked]",
											exception: error
										};
										this.logger.logError(JSON.stringify(logObj));
									}).catch((ex) => {
										let logObj = {
											method: methodName2,
											request: "token : [masked]",
											exception: ex
										};
										this.logger.logError(JSON.stringify(logObj));
									});
							}
						} else {
							this.is_loader = false;
							this.sharedService.setLoader('dashboard', false);
							this.router.navigate(['./verify-contact-warning']);
							// this.router.navigate(['./otp-verify/' + this.person_details['id']]);
						}
					} else {
						this.localStorageService.remove('token');
						this.router.navigate(['./sign-in']);
					}
				}, (error) => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						exception: error
					};
					this.logger.logError(JSON.stringify(logObj));
				}).catch((ex) => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						exception: ex
					};
					this.logger.logError(JSON.stringify(logObj));
				});;
		} else {
			this.router.navigate(['./sign-in']);
		}
	}
	ngOnInit() {
	}

	getRewardDetail(customer_id: string) {
		if (!this.is_loader) {
			this.is_loader = true;
			this.sharedService.setLoader('dashboard', true);
		}
		let requestObj = {
			"method": "get_token",
			"customer_id": customer_id,
			"key": GlobalVariable.rewardsApiKey
		};
		let methodName = this.constructor.name + '.rewardAPICall';
		this.sharedService.rewardAPICall(requestObj)
			.then(res => {
				let logObj = {
					method: methodName,
					request: requestObj,
					response: res
				};
				this.logger.logInfo(JSON.stringify(logObj));
				if (res != undefined && res.result == "success") {
					this.reward_token = res.token;
					this.reward_url = this.reward_url + '/' + res.token;
					this.sharedService.setRewardToken(res.token);
					let req = {
						"method": "lookup",
						"customer_id": customer_id,
						"key": GlobalVariable.rewardsApiKey
					};
					this.sharedService.rewardAPICall(req)
						.then(res => {
							let logObj = {
								method: methodName,
								request: requestObj,
								response: res
							};
							this.logger.logInfo(JSON.stringify(logObj));
							if (this.is_loader) {
								this.is_loader = false;
								this.sharedService.setLoader('dashboard', false);
							}
							if (res != null && !res.hasOwnProperty("result")) {
								this.rewardDetails = res;
							} else {
								this.enrollForReward();
								//this.rewardDetails = undefined;
							}
						});
				} else {
					this.enrollForReward();
				}
			}, (error) => {
				let logObj = {
					method: methodName,
					request: requestObj,
					exception: error
				};
				this.logger.logError(JSON.stringify(logObj));
			}).catch((ex) => {
				let logObj = {
					method: methodName,
					request: requestObj,
					exception: ex
				};
				this.logger.logError(JSON.stringify(logObj));
			});
	}

	addUpdateMetaTags() {
		this.title.setTitle('Home | Pogo Energy');
		const titleTag = this.meta.getTag('name=title');

		if (titleTag != undefined) {
			this.meta.updateTag({ name: 'title', content: 'Home | Pogo Energy' });
		} else {
			this.meta.addTag({ name: 'title', content: 'Home | Pogo Energy' });
		}

		const descriptionTag = this.meta.getTag('name=description');

		if (descriptionTag != undefined) {
			this.meta.updateTag({ name: 'description', content: 'Save money. Save the world. Save up to $300 a year with 100% clean energy. Get no deposit electricity without the BS (bill shock). Cancel at any time.' });
		} else {
			this.meta.addTag({ name: 'description', content: 'Save money. Save the world. Save up to $300 a year with 100% clean energy. Get no deposit electricity without the BS (bill shock). Cancel at any time.' });
		}
	}

	ngOnDestroy() {
		this.title.setTitle('Pogo Energy');
		const titleTag = this.meta.getTag('name=title');

		if (titleTag != undefined) {
			this.meta.updateTag({ name: 'title', content: 'Pogo Energy' });
		}

		const descriptionTag = this.meta.getTag('name=description');

		if (descriptionTag != undefined) {
			this.meta.updateTag({ name: 'description', content: '' });
		}
		// this.localStorageService.remove('skip_otp');
	}

	enrollForReward() {
		if (!this.is_loader) {
			this.is_loader = true;
			this.sharedService.setLoader('dashboard', true);
		}
		this.sharedService.getUserConfig('reward_amount')
			.then(res => {
				if (res !== undefined && res.status === "success") {
					let conf_data = res.result[0];
					let methodName = this.constructor.name + '.enrollToRewardProgram';
					this.sharedService.enrollToRewardProgram(this.person_details, conf_data.value)
						.then(res => {
							let logObj = {
								method: methodName,
								request: this.person_details,
								response: res
							};
							this.logger.logInfo(JSON.stringify(logObj));
							if (res != undefined && res.result == "success") {
								this.getRewardDetail(this.person_details['accountNumber']);
							}
						}, (error) => {
							let logObj = {
								method: methodName,
								request: this.person_details,
								exception: error
							};
							this.logger.logError(JSON.stringify(logObj));
						}).catch((ex) => {
							let logObj = {
								method: methodName,
								request: this.person_details,
								exception: ex
							};
							this.logger.logError(JSON.stringify(logObj));
						});
				}
			});
	}

	payNow() {
		if (this.is_payment_make) {
			if (this.is_not_enroll_sg) {
				this.dialog.open(DashboardInfo);
			} else {
				this.router.navigate(['./make-payment']);
			}
		} else {
			this.is_payment_make = false;
		}
	}

}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'dashboard-info',
	// tslint:disable-next-line:max-line-length
	template: '<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"><mat-icon>&#xE5CD;</mat-icon></button><div class="dialog-info"><p>We’re unable to complete your enrollment at this time. We will automatically retry your enrollment when our systems are back online. If you have any questions please chat with us or call us at 888.764.6669.</p></div></div><div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true">Ok</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class DashboardInfo {

}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'cash-only',
	// tslint:disable-next-line:max-line-length
	template: `<div class="dialog-main"><h3 class="text-center">Cash Only Payment</h3><p>Due to recent fraudulent credit or debit card activity, we are only accepting cash payments on your account at this time.</p></div><div class="footer" style=" display: flex;"><button mat-button class="double-block-btn border-b-none dialog-btn-border-r" [mat-dialog-close]="true">Cancel</button><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="resetPassword()">Continue</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class CashOnlyDialog {
	// tslint:disable-next-line:max-line-length
	constructor(private router: Router) {

	}
	resetPassword() {
		this.router.navigate(['./make-payment']);
	}
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard/dashboard.component.ts